import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';

import { TokenStorageService } from '../token-storage.service';

/**
 * Keeps waiter and kitchen sessions out of the dashboard layout: every
 * `/dashboard`, `/pages/*`, `/onboarding/*` and `/admin` route sits under it,
 * and a service-only session is sent to its own screen instead.
 */
@Injectable({ providedIn: 'root' })
export class MarsOnlyGuard implements CanActivate {
  constructor(private tokenStorage: TokenStorageService, private router: Router) {}

  canActivate(): true | UrlTree {
    return this.tokenStorage.isMarsOnly()
      ? this.router.parseUrl(this.tokenStorage.landingUrl())
      : true;
  }
}

/**
 * Unknown urls go to where the session starts: the dashboard, or the waiter
 * or kitchen screen. Signed-out sessions are then sent to login by the
 * guards of that route.
 */
@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(private tokenStorage: TokenStorageService, private router: Router) {}

  canActivate(): UrlTree {
    return this.router.parseUrl(this.tokenStorage.landingUrl());
  }
}
